import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { Centered, Loader } from '../../../../components'
import SingleNoteDom from '../../../../components/Notes/SingleNote'
import { SingleMessage } from '../../../../components/Screens/Estate/Store/CustomMessage'
import {
    deleteStoreMessageAndCheckDevices as deleteStoreMessageAction,
    fetchStoreMessages as fetchStoreMessagesAction,
} from '../../../../actions/customMessages'
import { getIsWorking, getStoreCustomMessages } from '../../../../reducers/customMessages'

function CustomMessagesList({ deleteStoreMessageAndCheckDevices, isWorking, messages }) {
    const { t } = useTranslation()

    if (isWorking) {
        return (
            <Centered horizontal>
                <Loader />
            </Centered>
        )
    }

    return messages.map(({ id, index, message }) => (
        <SingleNoteDom
            note={{
                note: <SingleMessage index={index} message={message} />,
            }}
            removeConfirmation={t('custom-message-remove-confirm', { message })}
            onClickDelete={() => deleteStoreMessageAndCheckDevices(id, message)}
            key={id}
        />
    ))
}

CustomMessagesList.propTypes = {
    deleteStoreMessageAndCheckDevices: PropTypes.func.isRequired,
    fetchStoreMessages: PropTypes.func.isRequired,
    isWorking: PropTypes.bool.isRequired,
    messages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    storeCode: PropTypes.string,
}

CustomMessagesList.defaultProps = {
    storeCode: null,
}

/**
 * Maps state to props
 * @param {Object} state
 */
function mapStateToProps(state) {
    return {
        isWorking: getIsWorking(state),
        messages: getStoreCustomMessages(state),
    }
}

/**
 * Wraps every action to be dispatched
 * @param {Function} dispatch
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            deleteStoreMessageAndCheckDevices: deleteStoreMessageAction,
            fetchStoreMessages: fetchStoreMessagesAction,
        },
        dispatch
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomMessagesList)
